import React, { Component } from 'react'
// import CircularProgress from '../useful/CircularProgress'
// import StagesManager from '../StagesManager'
import StagesManager from '../components/StagesManager'
import StageDownloader from './StageDownloader'
import StageQueue from './StageQueue'
import StageUploader from './StageUploader'
export default class Downloader extends Component {
    state = {
        stage: 0,
        activeTab: 0,
        stageTab: [
            { name: 'Queue' },
            { name: 'Downloading' },
            { name: 'Uploading' },
        ]
    }
    changePage = (key, stage, index) => {
        console.log(key)
        window.scrollTo({ top: 0, behavior: 'smooth' })
        this.stageManager.changeStage(key)
        this.setState({ stage })
    }
    render() {
        return (
            <div className='h-100 scroll-no-scrollbar w-100'>
                <div className='flexcb' style={{ backgroundColor: '#e1e1e1', position: 'sticky', top: '0' }}>
                    {this.state.stageTab.map((prop, index) => {
                        return (
                            <div onClick={() => { this.changePage(index); this.setState({ activeTab: index }) }} className={this.state.activeTab == index ? 'flexcc cursor-pointer w-100 p-2 selected-tab' : 'flexcc cursor-pointer w-100 p-2'}>
                                <p className='fw-600 text-small'>{prop.name}</p>
                            </div>
                        )
                    })}

                    {/* <div onClick={() => this.changePage(1, "Downloading", index)} className={this.state.activeTab == index ? 'flexcc cursor-pointer w-100 py-2 selected-tab' : 'flexcc cursor-pointer w-100 py-2'}>
                        <p>Downloading</p>
                    </div>
                    <div onClick={() => this.changePage(2, "Uploading", index)} className={this.state.activeTab == index ? 'flexcc cursor-pointer w-100 py-2 selected-tab' : 'flexcc cursor-pointer w-100 py-2'}>
                        <p>Uploading</p>
                    </div> */}
                </div>
                <StagesManager ref={el => this.stageManager = el} fast={true}>
                    <StageQueue setData={this.setData} initData={this.state.data} changePage={this.changePage} pages={this.state.pages} stage={0} user={this.props.user} openMobileMenu={this.openMobileMenu} addNotif={this.addNotif} postInformation={this.postInformation} clearData={this.clearData} stageName={'Queue'} />
                    <StageDownloader setData={this.setData} initData={this.state.data} changePage={this.changePage} pages={this.state.pages} stage={1} user={this.props.user} openMobileMenu={this.openMobileMenu} addNotif={this.addNotif} postInformation={this.postInformation} clearData={this.clearData} stageName={'Downloading'} />
                    <StageUploader setData={this.setData} initData={this.state.data} changePage={this.changePage} pages={this.state.pages} stage={2} user={this.props.user} openMobileMenu={this.openMobileMenu} addNotif={this.addNotif} postInformation={this.postInformation} clearData={this.clearData} stageName={'Uploading'} />
                </StagesManager>
            </div>
        )
    }
}
